/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Food Security Exchange API
 * REST API for the FSE platform. Endpoints by BRS module (PLAN.md §5).
 * OpenAPI spec version: 0.0.1
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import { fseAxios } from '../../client';




/**
 * @summary Liveness probe (process up, no downstream I/O)
 */
export const healthControllerLiveness = (
    
 signal?: AbortSignal
) => {
      
      
      return fseAxios<void>(
      {url: `/health`, method: 'GET', signal
    },
      );
    }
  



export const getHealthControllerLivenessQueryKey = () => {
    return [
    `/health`
    ] as const;
    }

    
export const getHealthControllerLivenessQueryOptions = <TData = Awaited<ReturnType<typeof healthControllerLiveness>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthControllerLiveness>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHealthControllerLivenessQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof healthControllerLiveness>>> = ({ signal }) => healthControllerLiveness(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof healthControllerLiveness>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type HealthControllerLivenessQueryResult = NonNullable<Awaited<ReturnType<typeof healthControllerLiveness>>>
export type HealthControllerLivenessQueryError = unknown


export function useHealthControllerLiveness<TData = Awaited<ReturnType<typeof healthControllerLiveness>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthControllerLiveness>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof healthControllerLiveness>>,
          TError,
          Awaited<ReturnType<typeof healthControllerLiveness>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useHealthControllerLiveness<TData = Awaited<ReturnType<typeof healthControllerLiveness>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthControllerLiveness>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof healthControllerLiveness>>,
          TError,
          Awaited<ReturnType<typeof healthControllerLiveness>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useHealthControllerLiveness<TData = Awaited<ReturnType<typeof healthControllerLiveness>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthControllerLiveness>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Liveness probe (process up, no downstream I/O)
 */

export function useHealthControllerLiveness<TData = Awaited<ReturnType<typeof healthControllerLiveness>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthControllerLiveness>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getHealthControllerLivenessQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Readiness probe (downstream dependency checks)
 */
export const healthControllerReadiness = (
    
 signal?: AbortSignal
) => {
      
      
      return fseAxios<void>(
      {url: `/health/ready`, method: 'GET', signal
    },
      );
    }
  



export const getHealthControllerReadinessQueryKey = () => {
    return [
    `/health/ready`
    ] as const;
    }

    
export const getHealthControllerReadinessQueryOptions = <TData = Awaited<ReturnType<typeof healthControllerReadiness>>, TError = void>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthControllerReadiness>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHealthControllerReadinessQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof healthControllerReadiness>>> = ({ signal }) => healthControllerReadiness(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof healthControllerReadiness>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type HealthControllerReadinessQueryResult = NonNullable<Awaited<ReturnType<typeof healthControllerReadiness>>>
export type HealthControllerReadinessQueryError = void


export function useHealthControllerReadiness<TData = Awaited<ReturnType<typeof healthControllerReadiness>>, TError = void>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthControllerReadiness>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof healthControllerReadiness>>,
          TError,
          Awaited<ReturnType<typeof healthControllerReadiness>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useHealthControllerReadiness<TData = Awaited<ReturnType<typeof healthControllerReadiness>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthControllerReadiness>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof healthControllerReadiness>>,
          TError,
          Awaited<ReturnType<typeof healthControllerReadiness>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useHealthControllerReadiness<TData = Awaited<ReturnType<typeof healthControllerReadiness>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthControllerReadiness>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Readiness probe (downstream dependency checks)
 */

export function useHealthControllerReadiness<TData = Awaited<ReturnType<typeof healthControllerReadiness>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthControllerReadiness>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getHealthControllerReadinessQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




